"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateSearchNode = void 0;
const NODE_TYPE = 'AGGREGATE-SEARCH';
const BaseNode_1 = require("../../BaseNode");
const LookupHelper_1 = require("../LookupHelper");
const Schema = __importStar(require("./schema.json"));
const DEFAULT_MAX_RESULTS = 4;
const MAX_UNDEFINED_RESULTS = 10000; //Picked a random large number as the limit if a max was not specified
/**
 * the purpose of this node is to provide a way to look up multiple aggregate ids based on the value of a single attribute
 */
class AggregateSearchNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            var _a, _b, _c, _d;
            const result = {
                exists: false,
                aggregateIdList: undefined,
                aggregateIdArray: [],
                itemsArray: [],
                successfulLookup: false,
            };
            const { aggregateType, attributeName, strategy } = this.config;
            const strategyToUse = strategy || LookupHelper_1.LookupConfigSchema.default;
            if ((0, LookupHelper_1.hasStrategyPreReqs)(strategyToUse, (_a = this.accessorMap) === null || _a === void 0 ? void 0 : _a.ONLINE_ATTRIB_LOOKUP, (_b = this.accessorMap) === null || _b === void 0 ? void 0 : _b.OFFLINE_ATTRIB_LOOKUP)) {
                const inputs = await this.asynchronousResolveInputs(nodeMap);
                const { attributeValueSource } = inputs;
                if (aggregateType && attributeName && attributeValueSource) {
                    const value = await (0, LookupHelper_1.lookupValue)((_c = this.accessorMap) === null || _c === void 0 ? void 0 : _c.ONLINE_ATTRIB_LOOKUP, (_d = this.accessorMap) === null || _d === void 0 ? void 0 : _d.OFFLINE_ATTRIB_LOOKUP, strategyToUse, {
                        aggregateType,
                        attributeName,
                        attributeValue: attributeValueSource,
                        limit: this.config.maxResults || MAX_UNDEFINED_RESULTS,
                    });
                    if (value) {
                        result.exists = value.results.length > 0;
                        result.successfulLookup = value.lookupSucceeded;
                        const maxOutputs = this.config.maxResults || DEFAULT_MAX_RESULTS;
                        const outputValues = value.results.slice(0, maxOutputs);
                        result.aggregateIdArray = (this.config.maxResults ? outputValues : value.results).map((val) => val.id); //Take full results if max results was not specified
                        result.itemsArray = (this.config.maxResults ? outputValues : value.results).map((val) => val);
                        result.aggregateIdList = result.aggregateIdArray.join(',');
                        // Add in the aggregate ids, set to undefined if not present
                        for (let i = 0; i < maxOutputs; i++) {
                            result[`aggregateId${i + 1}`] = (outputValues[i] && outputValues[i].id) || undefined;
                        }
                    }
                }
            }
            // Accessor was not available, can not run this transform
            return result;
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Aggregate search is not allowed as a synchronously resolving node');
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        var _a;
        //grab the available aggregate types if available
        const aggregateTypes = this.schemaLookup.getAggregates && this.schemaLookup.getAggregates();
        // grab the available event schemas
        let aggregateSchema = null;
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.aggregateType) {
            // we use this trick to get a full copy of the schema. This may end up being too slow, but let's try for now.
            aggregateSchema = JSON.parse(JSON.stringify(this.schemaLookup.getSchema(this.config.aggregateType) || {}));
        }
        const attributeNames = aggregateSchema && aggregateSchema.properties ? Object.keys(aggregateSchema.properties) : [];
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: {
                exists: { type: 'boolean', description: 'Exists?' },
                successfulLookup: { type: 'boolean', description: 'Lookup Successful?' },
                aggregateIdArray: { type: 'array', items: { type: 'string' }, description: 'Aggregate Id Array' },
                itemsArray: { type: 'array', items: { type: 'object', properties: {} }, description: 'Aggregate Object Array' },
                aggregateIdList: { type: 'string', description: 'Aggregate Id List' },
            },
        };
        //Now add in the dynamic portion of the outputs
        const maxOutputs = this.config.maxResults || DEFAULT_MAX_RESULTS;
        for (let i = 0; i < maxOutputs; i++) {
            OutputParams.properties[`aggregateId${i + 1}`] = { type: 'string' };
        }
        return Object.assign(Object.assign({}, Schema), { InputParams: this._interfaceDefinition.definitions.InputParams, OutputParams: OutputParams, ConfigParams: {
                type: 'object',
                properties: {
                    strategy: LookupHelper_1.LookupConfigSchema,
                    aggregateType: {
                        description: 'Aggregate Type',
                        type: 'string',
                        enum: aggregateTypes || undefined,
                    },
                    attributeName: {
                        description: 'Attribute Name',
                        type: 'string',
                        enum: attributeNames,
                    },
                    maxResults: {
                        description: 'Maximum Results',
                        type: 'number',
                    },
                },
            } });
    }
}
exports.AggregateSearchNode = AggregateSearchNode;
AggregateSearchNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Aggregate Search',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=AggregateSearch.js.map